/**
 * A helper for asynchronously loading scripts.
 *
 * Provides a callback interface for passing a function that will only be
 * called if the script is successfully added to the page.
 *
 * @param {String} url The URL for the script to be loaded.
 * @param {Function} [callback] A function to be called once the script
 * successfully loads. Not required.
 * @param {Function} [errorCallback] A function to be called if the script
 * unsuccessfully loads. Not required.
 * @returns {void}
 * @example
 *
 * loadScript('backup.js', function () {
 *   // anything that depends on that script loading
 * })
 */
export default function loadScript (url, callback, errorCallback) {
  var script = document.createElement('script');
  script.src = url;

  if (callback) script.onload = callback;
  if (errorCallback) script.onerror = errorCallback;

  document.body.appendChild(script);
}



// WEBPACK FOOTER //
// ./utils/load-script.js